import { render, staticRenderFns } from "./PolicyRun.vue?vue&type=template&id=294bda74"
import script from "./PolicyRun.vue?vue&type=script&lang=js"
export * from "./PolicyRun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports